import React from 'react';

import { Button, Box, Typography, SxProps, Theme } from '@mui/material';

import { UserFilterOption } from '../../constants/FilterOptions';
import MenuOption from '../../types/MenuOption';
import UserFilterCheckboxMenu from '../CheckboxMenu/UserFilterCheckboxMenu';

import './MenuButton.scss';

type Props = {
  handleSelection: (
    option: MenuOption<UserFilterOption>,
    checked: boolean
  ) => void;
  IconOpen: React.FC<React.SVGProps<SVGSVGElement>>;
  IconClosed: React.FC<React.SVGProps<SVGSVGElement>>;
  options: MenuOption<UserFilterOption>[];
  title: string;
  sx?: SxProps<Theme>;
};

const UserFilterMenuButton: React.FC<Props> = ({
  options,
  handleSelection,
  IconOpen,
  IconClosed,
  title,
  sx,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const count = options.filter((option) => option.selected).length;
  const open = Boolean(anchorEl);
  const highlighted = open || count > 0;
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={sx}>
      <Button
        sx={{
          borderRadius: '8px',
        }}
        disableElevation
        variant={'contained'}
        color={highlighted ? 'primaryLight' : 'defaultWhite'}
        onClick={handleClick}
      >
        {count !== 0 && (
          <Box className='count-label'>
            <Typography color='white' variant='caption'>
              {count}
            </Typography>
          </Box>
        )}
        {highlighted ? <IconOpen /> : <IconClosed />}
        <Typography color={highlighted ? 'text.primary' : 'text.secondary'}>
          {title}
        </Typography>
      </Button>
      <UserFilterCheckboxMenu
        handleSelection={handleSelection}
        options={options}
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        id={id}
      />
    </Box>
  );
};

export default UserFilterMenuButton;
